import React from 'react';
import { add } from '../../../lib/api/contract';
import { ContractForm } from './ContractForm';
import { getContractGuid, normalizeContractPayload, normalizeContractResponse } from './formUtils';

const findCreatedContract = (rows, submittedContract, createdContract) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return null;
  }

  const createdGuid = getContractGuid(createdContract);

  if (createdGuid) {
    const byGuid = rows.find(row => String(getContractGuid(row)) === String(createdGuid));
    if (byGuid) {
      return byGuid;
    }
  }

  return (
    rows.find(
      row =>
        String(row.club_entities_id ?? '') === String(submittedContract.club_entities_id ?? '') &&
        String(row.players_entities_id ?? '') === String(submittedContract.players_entities_id ?? '') &&
        String(row.authorized_contact_id ?? '') === String(submittedContract.authorized_contact_id ?? '') &&
        String(row.contract_durations_id ?? '') === String(submittedContract.contract_durations_id ?? '') &&
        String(row.valid_to ?? '').slice(0, 10) === String(submittedContract.valid_to ?? '').slice(0, 10)
    ) || rows[0]
  );
};

export function Add({ onClose, onSave, onCreated }) {
  return (
    <ContractForm
      initialContract={{}}
      mode="add"
      onSubmit={async contract => {
        const created = await add(normalizeContractPayload(contract));
        const normalizedCreated = normalizeContractResponse(created);
        const createdGuid = getContractGuid(normalizedCreated);
        const createdContract = { ...normalizedCreated, document_guid: createdGuid };
        const savedRows = await onSave?.();
        const contractForEdit =
          getContractGuid(createdContract) ? createdContract : findCreatedContract(savedRows, contract, createdContract);

        if (onCreated) {
          await onCreated(contractForEdit || createdContract);
          return;
        }
        onClose?.();
      }}
    />
  );
}
